import React, { useState } from 'react';
import {
  IconButton,
  Stack,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import StringUtils from '../../../common/services/StringUtils';
import CustomDialog from '../../../common/components/CustomDialog';
import { gql, useMutation } from '@apollo/client';
import clientGraphql from '../../../../common/apollo-graphql';

const SAVE_REFERRAL_STATUS = gql`
  mutation SaveReferralStatus($uuid: String!, $status: String!) {
    save_referral_status(uuid: $uuid, status: $status)
  }
`;

export default function ActiveReferralStatusCell({ data, refresh }) {
  const [open, setOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [saveReferralStatus] = useMutation(SAVE_REFERRAL_STATUS, {client: clientGraphql});

  const { id: uuid, status } = data.referral;
  const statusText = data.getReferrerStatus();
  const editableStatuses = ['sending_fax', 'faxed_successfully'];
  const isEditable = editableStatuses.includes(status);

  const handleOpen = (e) => {
    e.stopPropagation();
    setSelectedStatus(status);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleSave = async () => {
    if (selectedStatus !== status) {
      try {
        await saveReferralStatus({
          variables: {
            uuid: uuid,
            status: selectedStatus,
          },
        });

        setOpen(false);

        if (refresh) refresh();
      } catch (error) {
        console.error('Failed to update referral status:', error.message);
      }
    } else {
      setOpen(false);
    }
  };

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="body2">{statusText}</Typography>
        {isEditable && (
          <IconButton size="small" color="primary" onClick={handleOpen}>
            <EditIcon fontSize="small" />
          </IconButton>
        )}
      </Stack>

      <CustomDialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
        <DialogTitle>Edit Referral Status</DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel id="referral-status-select-label">Select Status</InputLabel>
            <Select
              labelId="referral-status-select-label"
              value={selectedStatus}
              label="Select Status"
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              {editableStatuses.map((s) => (
                <MenuItem key={s} value={s}>
                  {StringUtils.toTitleCase2(s.replaceAll('_', ' '))}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={handleSave}
            variant="contained"
            color="primary"
            disabled={selectedStatus === status}
          >
            Save
          </Button>
        </DialogActions>
      </CustomDialog>
    </>
  );
}
